import React, { useState, useEffect } from 'react';
import 'katex/dist/katex.min.css';
import renderMathInElement from "katex/dist/contrib/auto-render.js";
import { applyKatexWrap, flattenKatexUnderlines } from 'global/katexWrap';

import './index.css';

type DragAndDropBlankPreviewProps = {
    question: any;
    showAnswer: boolean;
};

function DragAndDropBlankPreview({ question, showAnswer } : DragAndDropBlankPreviewProps) {
    const [questionHelper, setQuestionHelper] = useState(null);

    const generateQuestionHelper = (helper) => {
        let html = helper;

        const regex = /\[\[(.*?)\]\]/g;
        let counter = 1;

        html = html.replace(regex, (_match) => {
            const index = counter++;
            let answer = null;

   
            answer = showAnswer ? question.answers.find(answer => answer[1] === index) : null;
            if (answer) {
                return `
                    <div class='${showAnswer
                        ? 'katex digitalSHSATPreview__blankQuestionHelperBoxFilled--correct'
                        : 'katex digitalSHSATPreview__blankQuestionHelperBoxFilled'
                    }' data-index='${index}' data-text='${answer[0]}'>
                        ${question.dragAndDropItems.find(item => item.id === answer[0])?.answer}
                    </div>
                `
            }
            return `<div class='katex digitalSHSATPreview__blankQuestionHelperBox' data-index='${index}'></div>`
        });
        setQuestionHelper(html);
    }

    const renderKatex = () => {
        const katex = document.getElementsByClassName('katex');
        for (let i = 0; i < katex.length; i++) {
            renderMathInElement(katex[i], {
                delimiters: [
                    {left: '$$', right: '$$', display: true},
                    {left: '$', right: '$', display: false},
                    {left: '\\(', right: '\\)', display: false},
                    {left: '\\[', right: '\\]', display: true}
                ],
                trust: true
            });

            katex[i].innerHTML = katex[i].innerHTML.replaceAll('&nbsp;', ' ');
        }

        // Wraps unconditionally (the subject test was commented out before this
        // helper existed). Kept as-is; the array guard inside is what matters.
        applyKatexWrap(document, { enabled: true });

        flattenKatexUnderlines(document);

        const math = document.querySelectorAll('.katex-mathml');
        for (let i = 0; i < math.length; i++) {
            math[i].remove();
        }
    }

    useEffect(() => {
        generateQuestionHelper(question.questionHelper?.questionHelper);
    }, []);

    useEffect(() => {
        generateQuestionHelper(question.questionHelper?.questionHelper);
    }, [question, showAnswer]);

    useEffect(() => {
        renderKatex();
    }, [questionHelper]);

    return (
        <>
            <div className='digitalSHSATPreview__blankItems'>
                {question.dragAndDropItems.filter(item => (
                    showAnswer ? !question.answers.find(answer => answer[0] === item.id) : true
                )).map(item => (
                    <p 
                        key={item.id}
                        className='katex digitalSHSATPreview__blankItem'
                    >
                        {item.answer}
                    </p>
                ))}
            </div>
            <div className='digitalSHSATPreview__blankQuestionHelper'>
                <p
                    id={question.questionHelper.id}
                    className='katex digitalSHSATPreview__blankQuestionHelperText'
                    dangerouslySetInnerHTML={{ __html: questionHelper }}
                ></p>
            </div>
        </>
    );
}

export default DragAndDropBlankPreview;